import { render, staticRenderFns } from "./CompCalcApp.vue?vue&type=template&id=12c39080&scoped=true"
import script from "./CompCalcApp.vue?vue&type=script&lang=js"
export * from "./CompCalcApp.vue?vue&type=script&lang=js"
import style0 from "./CompCalcApp.vue?vue&type=style&index=0&id=12c39080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c39080",
  null
  
)

export default component.exports